
import { useState } from 'react';
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";

interface PhoneVerificationProps {
  phoneNumber: string;
  onVerificationComplete: () => void;
  isOpen: boolean;
  onClose: () => void;
}

const PhoneVerification = ({ phoneNumber, onVerificationComplete, isOpen, onClose }: PhoneVerificationProps) => {
  const [verificationCode, setVerificationCode] = useState('');
  const [loading, setLoading] = useState(false);

  const handleVerifyCode = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!verificationCode) {
      toast.error("Por favor ingresa el código de verificación");
      return;
    }

    try {
      setLoading(true);
      const { error } = await supabase.auth.verifyOtp({
        phone: `+1${phoneNumber}`,
        token: verificationCode,
        type: 'sms'
      });

      if (error) throw error;

      toast.success("Número de teléfono verificado exitosamente");
      onVerificationComplete();
      onClose();
    } catch (error: any) {
      console.error('Verification error:', error);
      toast.error(error.message || "Error al verificar el código");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            Verificar número de teléfono
          </DialogTitle>
        </DialogHeader>
        <form onSubmit={handleVerifyCode} className="space-y-4 mt-4">
          <div className="space-y-2">
            <Label htmlFor="verificationCode" className="text-base font-medium">
              Código de verificación
            </Label>
            <Input
              id="verificationCode"
              type="text"
              value={verificationCode}
              onChange={(e) => setVerificationCode(e.target.value)}
              className="h-12 text-lg"
              placeholder="Ingresa el código"
              maxLength={6}
            />
          </div>
          <Button 
            type="submit"
            disabled={loading}
            className="w-full h-12 text-lg bg-orange-500 hover:bg-orange-600 transition-all duration-200 shadow-lg hover:shadow-xl"
          >
            {loading ? "Verificando..." : "Verificar código"}
          </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default PhoneVerification;
